// extracted by mini-css-extract-plugin
export default {"mainCad":"Diretor_mainCad__EbKLK","cinetec":"Diretor_cinetec__5t33g","formCad":"Diretor_formCad__D8v+8","inputDir":"Diretor_inputDir__byIxf","btnDir":"Diretor_btnDir__P-2Wi"};